import { closestCorners, DndContext, DragEndEvent, DragOverlay } from '@dnd-kit/core';
import { restrictToParentElement, restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { observer } from 'mobx-react';
import { ChangeEvent } from 'react';
import Skeleton from 'react-loading-skeleton';
import { DspListItem } from '../../components/DspListItem/DspListItem';
import { dispatchingRulesStore } from '../../stores/dispatchingRulesStore';
import { LOCALES } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { dndAutoScrollOptionsDefault, dndOverlayAnimationDefault, DndSensors } from 'src/utils/dnd';
import { booleanNumberReverse, emptyArray } from 'src/utils/helpers';
import { TOOLTIP_DURATION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Input from 'src/view/components/Controls/Input/Input';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import Text from '~/view/components/Text/Text';
import './style.scss';

export const DspList = observer(() => {
  const changeInput = (event: ChangeEvent<HTMLInputElement>) => {
    const value: number = Number(event.target.value.replace(/\D/, ''));

    if (value >= 1440) {
      if (dispatchingRulesStore.driverTimeout && dispatchingRulesStore.driverTimeout >= 1440) return;
      dispatchingRulesStore.changeDriverTimeout(1440);
    } else {
      dispatchingRulesStore.changeDriverTimeout(!value || isNaN(value) ? undefined : value);
    }
  };

  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    if (!dispatchingRulesStore.selectedProfile) return;
    if (over && over.id !== '0' && active.id !== over.id) {
      dispatchingRulesStore.updateProfile({ priority: { startId: active.id, overId: over.id } });
    }
    dispatchingRulesStore.setSelectedDsp(null);
  };

  const toggleDAT = () => {
    dispatchingRulesStore.updateProfile({ use_dat: booleanNumberReverse(dispatchingRulesStore.selectedProfile?.use_dat) });
  };

  const isUseDat = Boolean(dispatchingRulesStore.selectedProfile?.use_dat);

  return (
    <div className="dsp-list d-flex flex-column flex-1">
      {dispatchingRulesStore.selectedProfile ? (
        <div className="d-flex flex-column">
          <div className="pos-relative d-flex flex-row align-items-center mb-3 ml-4">
            <Switcher status={dispatchingRulesStore.selectedProfile?.use_dat} onChange={toggleDAT} />
            <Text
              type="switcher-label"
              text="optimised_dat_toggle"
              tooltip={{ message: 'optimised_dat_infotip', duration: TOOLTIP_DURATION.EXTRA_LARGE, maxWidth: 303, iconSize: 16 }}
            />
          </div>
          <Input
            key={`${dispatchingRulesStore.selectedProfile.id}_driver_timeout`}
            type="text"
            className={`dsp-list__input input-number family-medium text-size-16 ${localeStore.language === LOCALES.EN ? 'text-end' : 'text-start'} `}
            wrapperClassName={`dsp-list__input-wrapper ml-4 ${isUseDat ? 'disabled' : ''}`}
            // space required !!!
            value={dispatchingRulesStore.driverTimeout?.toString() || ' '}
            onInput={changeInput}
            error={!dispatchingRulesStore.driverTimeout}
            disabled={dispatchingRulesStore.loading || Boolean(dispatchingRulesStore.selectedProfile?.use_dat)}
          >
            <p className="dsp-list__input-text family-medium color-dark text-size-16">{localeStore.t('driver_acceptance_timeout')}</p>
          </Input>
        </div>
      ) : (
        <Skeleton width={360} height={46} style={{ marginBottom: 12.5, borderRadius: 12 }} className="ml-4" />
      )}

      <DndContext
        id="dsp"
        autoScroll={dndAutoScrollOptionsDefault}
        modifiers={[restrictToVerticalAxis, restrictToParentElement]}
        sensors={DndSensors()}
        collisionDetection={closestCorners}
        onDragStart={({ active }) => dispatchingRulesStore.setSelectedDsp(Number(active.id))}
        onDragCancel={() => dispatchingRulesStore.setSelectedDsp(null)}
        onDragEnd={handleDragEnd}
      >
        <ScrollableBlock className="dsp-list__container" showScrollbar>
          <ul className="d-flex flex-column pos-relative">
            {dispatchingRulesStore.selectedProfile
              ? dispatchingRulesStore.dspForRender.map((dsp, index) => <DspListItem key={dsp.id} dsp={dsp} index={index} />)
              : emptyArray(4).map((_, index) => (
                  <Skeleton key={index} height={30} width="100%" className="ml-4" style={{ marginTop: 7.5, marginBottom: 7.5, maxWidth: 360 }} />
                ))}
          </ul>
        </ScrollableBlock>

        <DragOverlay dropAnimation={dndOverlayAnimationDefault}>
          {dispatchingRulesStore.selectedDsp ? (
            <DspListItem
              dsp={dispatchingRulesStore.selectedDsp}
              index={dispatchingRulesStore.isSelectedDspIndex}
              isOverlayDsp
              className="dsp-list-item-drag_active"
            />
          ) : null}
        </DragOverlay>
      </DndContext>
    </div>
  );
});

// export const DspList = () => {
//   const handleDragEnd = ({ over }: DragEndEvent) => {
//     if (over) {
//     const overItemId: number = items.map((item) => item.id).indexOf(Number(over?.id));
//     const activeItemId: number = activeId ? items.map((item) => item.id).indexOf(Number(activeId)) : -1;
//     if (activeItemId !== overItemId) {
//       const overItemPriority: number | undefined = items.find((item) => item.id === Number(over?.id))?.priorityNumber || 0;
//       const activeItemPriority: number | undefined = items.find((item) => item.id === Number(activeId))?.priorityNumber || 0;

//       const getPriority = (priority: number) => {
//         if (activeItemPriority < overItemPriority) {
//           return priority === activeItemPriority ? overItemPriority : priority - 1;
//         } else return priority === activeItemPriority ? overItemPriority : priority + 1;
//       };

//       const changePriority = (item: IItem) => {
//         return {
//           id: item.id,
//           name: item.name,
//           priorityNumber: getPriority(item.priorityNumber),
//           status: item.status,
//         };
//       };

//       setItems(
//         items.map((item) =>
//           Math.min(activeItemPriority, overItemPriority) <= item.priorityNumber &&
//           item.priorityNumber <= Math.max(activeItemPriority, overItemPriority)
//             ? changePriority(item)
//             : item
//         )
//       );
//     }
// }
// setActiveId(null);
//   };
